import routes from 'src/router';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { DeleteDialog } from './components/DynamicTable/DynamicTable';
import { StyledEngineProvider } from '@mui/material/styles';
import './assets/css/global.css';
import { useRoutes } from 'react-router-dom';
import { useEffect } from 'react';
import { SentryConfig } from './config/config';
import { useLocation } from 'react-router';



// Sentry configuration
Sentry.init({
  dsn: SentryConfig.dsn,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});



const responseFunc = Response.prototype.json;

Response.prototype.json = async function () {
  try {
    return await responseFunc.call(this);
  } catch (err) {
    if (this.url.startsWith('https://prizeet-backend-dev')) {
      if (this.status === 401 || this.status === 403) {
        localStorage.removeItem('accessToken');
        window.location.href = '/attributes';
      }
    }
  }
};

function App() {
  const content = useRoutes(routes);
  const location = useLocation();

  useEffect(() => {
    Sentry.captureEvent({
      message: `Screen Viewed: [${location.pathname}]`,
      level: 'info',
      extra: {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        currentUser: localStorage.getItem('displayName') || 'No User'
      }
    })
  },[location.pathname]);

  const useHideUnimportantErrors = () => {




    useEffect(() => {
      function hideError(e) {
        if (
          e.message ===
          'ResizeObserver loop completed with undelivered notifications.'
        ) {
          const resizeObserverErrDiv = document.getElementById(
            'webpack-dev-server-client-overlay-div'
          );
          const resizeObserverErr = document.getElementById(
            'webpack-dev-server-client-overlay'
          );
          if (resizeObserverErr) {
            resizeObserverErr.setAttribute('style', 'display: none');
          }
          if (resizeObserverErrDiv) {
            resizeObserverErrDiv.setAttribute('style', 'display: none');
          }
        }
      }

      window.addEventListener('error', hideError);
      return () => {
        window.addEventListener('error', hideError);
      };
    }, []);
  };
  //useHideUnimportantErrors();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider>
        <CssBaseline />
        <DeleteDialog />
        {content}
        <Toaster />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
